module.exports = __webpack_public_path__ + "img/import_empty.f38fdb10.png";